exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Link_size_s {\n  font-size: 0.75em;\n  font-weight: 400; }\n\n.Link_type_article {\n  color: #0366d6;\n  text-decoration: none;\n  white-space: nowrap; }\n", ""]);

// exports
